import {Component, inject, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AppService} from 'src/app/shared/services/app.service';
import {SettingsService} from 'src/app/shared/services/settings.service';
import {FormService} from 'src/app/shared/services/form.service';
import {AlfaIdService} from '../alfa-id.service';
import {CacheService} from 'src/app/shared/services/cache.service';
import {NavigationService} from 'src/app/shared/services/navigation.service';
import {ROUTES} from 'src/app/shared/enums/routes.enum';
import {Subscription} from 'rxjs';
import {AlfaIdComponent} from "../alfa-id.component";

@Component({
  selector: 'app-refusal-traffic-alfaid',
  templateUrl: './refusal-traffic-alfaid.component.html',
  styleUrls: ['./refusal-traffic-alfaid.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AlfaIdComponent]
})
export class RefusalTrafficAlfaidComponent implements OnInit, OnDestroy {
  private readonly appService = inject(AppService);
  private readonly settingsService = inject(SettingsService);
  private readonly formService = inject(FormService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly alfaIdService = inject(AlfaIdService);
  private readonly cacheService = inject(CacheService);
  private readonly navigationService = inject(NavigationService);

  public isLoading = false;
  public error: string | null = null;
  private subscription = new Subscription();

  ngOnInit(): void {
    this.getAlfaIdInfoFromCode();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  // Получаем данные из Alfa ID по параметру code
  public getAlfaIdInfoFromCode(): void {
    const url: URL = new URL(window.location.href);
    const params: URLSearchParams = url.searchParams;
    const code: string | null = params.get('code');
    const applicationId: string | null = params.get('applicationId');

    if (code && applicationId) {
      this.isLoading = true;
      this.subscription.add(
        this.alfaIdService.getAlfaUseFromCode(false, true) // forProlongation: false, forRefusalTraffic: true
          .subscribe((res: any) => {
            if (res.result) {
              const {lastName, firstName, middleName} = res.value;
              this.alfaIdService.nameFromAlfaId = `${lastName} ${firstName?.charAt(0)}.${middleName?.charAt(0)}.`;

              // Если есть refusalTrafficApplicationId, то берем данные из кэша и отправляем клиента на страницу офферов
              if (res.value?.refusalTrafficApplicationId) {
                this.getOsagoByApplicationId(res.value?.refusalTrafficApplicationId);
              } else if (res.value?.error || !res.value?.refusalTrafficApplicationId) {
                this.navigationService.navigate(ROUTES.MainPage);
              }
            } else if (res.value?.error) {
              this.navigationService.navigate(ROUTES.MainPage);
            }
          })
      );
    }
  }

  // Получаем данные из кэша по applicationId
  public getOsagoByApplicationId(applicationId: string): void {
    this.isLoading = true;
    const urlParams = this.appService.getUrlParams();
    this.subscription.add(
      this.cacheService.getOsagoCacheByApplicationId(urlParams, applicationId)
        .subscribe(() => {
          this.isLoading = false;
          if (this.formService.form.valid) {
            this.navigationService.navigate(ROUTES.Offers);
          } else {
            this.navigationService.navigate(ROUTES.MainPage);
          }
        })
    );
  }

  // Кнопка авторизации через AlfaId
  public onAlfaIdAuth(): void {
    this.isLoading = true;
    this.alfaIdService.getAlfaIdUrl(false, true).subscribe((res: any) => {
      this.isLoading = false;
      if (res && res.result && res.value?.url) {
        window.location.href = res.value.url;
      } else {
        this.error = 'Ошибка получения ссылки AlfaId';
      }
    });
  }
}
